module.exports = "../images/economy-package@2x.jpg?v=88f2752";